import { getAuthData } from '@common/helpers/auth';
import Config from '../config/main';
import Helpers from '@common/helpers/helperFunctions';

export const getTerminalLanguage = () => {
  const authData = getAuthData();
  const { betshopid } = authData || {};
  const betshopIdUrl = Helpers.getUriParam("betshopid");
  const betshopId = betshopid || betshopIdUrl

  const customLang = Config.perBetshopLanguages.find((data) => data.ids.includes(+betshopId))?.lang;

  return customLang || Config.env.lang;
};
